import { Ticket } from "../../interface/ticket";

export default function TicketList({
  tickets,
  view,
  onSelectTicket,
}: {
  tickets: Ticket[];
  view: string;
  onSelectTicket: (ticket: Ticket) => void;
}) {
  // filter tickets based on view
  let filtered = tickets;
  if (view === "openTickets") {
    filtered = tickets.filter((t) => t.status !== "CLOSED");
  } else if (view === "closedTickets") {
    filtered = tickets.filter((t) => t.status === "CLOSED");
  }

  if (filtered.length === 0) {
    return <p className="text-gray-500">No tickets found.</p>;
  }

  function daysGone(pastDateStr: string): number {
    const today = new Date();
    const pastDate = new Date(pastDateStr);
    return Math.floor((today.getTime() - pastDate.getTime()) / (1000 * 60 * 60 * 24));
  }

  return (
    <div className="flex flex-col divide-y">
      {filtered.map((ticket) => (
        <div
          key={ticket._id}
          className="flex items-start justify-between py-4 cursor-pointer hover:bg-gray-50"
          onClick={() => onSelectTicket(ticket)} // 👈 open chat on click
        >
          <div>
            <h2 className="text-lg font-medium text-gray-900">
              {ticket.more_info[0].description}
            </h2>
            <div className="mt-1 flex flex-wrap gap-2 text-sm text-gray-500">
              <span>• {ticket.conversation.at(-1)?.time }</span>
              <span>• {daysGone(ticket.conversation.at(-1)?.time || "")} days</span>
              <span>• {ticket.conversation.length} {ticket.conversation.length === 1 ? "reply" : "replies"}</span>
            </div>
          </div>
          <div className="flex flex-col items-end gap-2">
            <span className="text-gray-900 font-semibold">#{ticket.ticket_id}</span>
            <span
              className="mt-1 flex flex-wrap gap-2 text-sm text-gray-500"
            >
              {ticket.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
